<label class="vtz-form__rank-container vtz-text" role="listitem" [attr.data-index]="index" #unrankedOption [attr.id]="'unranked-option-' + index">
  <div style="display: flex; align-items: center; gap: 10px;">
    @if (!isStringEmpty(unranked().choices[0].choiceDetails?.imageUrl)) {
      <img class="unranked-image" src="{{unranked().choices[0].choiceDetails?.imageUrl}}" [alt]="unranked().description">
    }  
    <div style="display: flex; flex-direction: column;">
      <div style="display: flex;align-items: center;">
        <p style="margin: 0;">{{ unranked().description }}</p>
  
        @if (!isStringEmpty(unranked().choices[0].choiceDetails?.webUrl)) {
          <a mat-icon-button 
             matTooltip="{{tooltipText}}"
             matTooltipPosition="above"
             href="{{unranked().choices[0].choiceDetails?.webUrl}}" 
             target="_blank">
            <mat-icon style="color: #365a8a !important;">info</mat-icon>
          </a>
        }
      </div>  
      <p style="margin: 0;">{{ unranked().description1 }}</p>
    </div>
  </div>
  <div class="focus-container">
    @if (isMobileScreen) {
      <button id="rankButton{{index}}" mat-mini-fab color="primary" [attr.aria-label]="'Rank'+ unranked().description" (click)="onRank() "
      style="color: white;" i18n>
        <mat-icon style="color: white;">arrow_upward</mat-icon>
      </button>
    } @else {
      <button id="rankButton{{index}}" mat-fab extended color="primary" [attr.aria-label]="'Rank'+ unranked().description" (click)="onRank() "
      style="color: white;" i18n>
        <mat-icon style="color: white;">arrow_upward</mat-icon>
        Rank
      </button>
    }
  </div>

</label>